import script from "./SearchEvent.vue?vue&type=script&lang=js"
export * from "./SearchEvent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__